import {Inject, Injectable, InjectionToken, Optional, PLATFORM_ID} from '@angular/core';
import {catchError, filter, map, take, timeout} from 'rxjs/operators';
import {loadShoppingCart} from '@store/actions/shopping-cart.action';
import {setUser} from '@store/actions/user.action';
import {Store} from '@ngrx/store';
import {AppState} from '@store/state/app.state';
import {setInjectionToken, shoppingCart} from '@store/actions/storage.action';
import {ActivatedRoute} from '@angular/router';
import {isPlatformBrowser} from '@angular/common';
import {AuthenticationService} from '@iw-shop/core/services/authentication.service';
import {of, TimeoutError} from "rxjs";
@Injectable({
    providedIn: 'root'
})
export class AppInitStorageService {

    private readonly isBrowser: boolean;

    constructor(
        private store: Store<AppState>,
        private activatedRoute: ActivatedRoute,
        private authenticationService: AuthenticationService,
        @Inject(PLATFORM_ID) platformId: Object
    ) {
        this.isBrowser = isPlatformBrowser(platformId);
    }

    init() {
        return new Promise<void>((resolve, reject) => {
            if (!this.isBrowser) {
                resolve();
            } else {
                this.activatedRoute.queryParams
                    .pipe(
                        take(2)
                    )
                    .subscribe(
                        p => {
                            if (p['token']) {
                                let payloadString = p['token'].split('.')[1];
                                if (payloadString) {
                                    // Vorab ausloggen, damit die Authentication-Cookies (insbesondere die Captcha-Authentifizierung) gelöscht werden
                                    this.authenticationService.logout();
                                    let payload: {
                                        userId: string,
                                        exp: number
                                    } = JSON.parse(atob(payloadString));
                                    this.store.dispatch(setInjectionToken({token: p['token'], expiredIn: Math.floor(new Date(payload.exp).getTime() / 1000)}));
                                    if (p['action'] == 'login') {
                                        this.store.dispatch(setUser({userId: payload.userId}))
                                    }
                                }
                            }
                            if (p['shoppingCartId'] &&
                                p['shoppingCartToken']) {
                                this.store.dispatch(shoppingCart({
                                    id: p['shoppingCartId'],
                                    token: p['shoppingCartToken']
                                }))
                            }
                        }
                    )

                //this.store.dispatch(resetAccessExpire());
                this.store.select(state => state).pipe(
                    take(1)
                )
                    .subscribe(
                        state => {
                            // Keine WarenkorbId, aber im Storage ist eine erfasst > Warenkorb neu laden
                            if (!state.shoppingCart.id &&
                                state.storage.shoppingCart?.id &&
                                state.storage.shoppingCart?.token) {
                                this.store.dispatch(loadShoppingCart({
                                    id: state.storage.shoppingCart.id,
                                    token: state.storage.shoppingCart.token
                                }));
                            }
                            // Keine UserId, aber im Storage ist eine erfasst > User neu laden
                            if (state.storage.userId) {
                                this.store.dispatch(setUser({userId: state.storage.userId}))
                            }
                        }
                    );

                this.store.select(state => state)
                    .pipe(
                        map(
                            state => {
                                return state;
                            }
                        ),
                        filter(state =>
                            (
                                state.shoppingCart.requestsCounter == state.shoppingCart.requestsDone
                            ) &&
                            (
                                state.user.isLoading === false ||
                                !state.storage.userId
                            )
                        ),
                        timeout(5000),  // Timeout after 5000 milliseconds (or 5 seconds)
                        catchError(error => {
                            resolve()
                            if (error instanceof TimeoutError) {
                                // Handle timeout error here, for example
                                return of(null);
                            } else {
                                // Rethrow the error if it's not a timeout
                                throw error;
                            }
                        }),
                        // Der Warenkorb muss geladen sein, bevor es weitergeht (externe Zahlsysteme).

                        take(1)
                    )
                    .subscribe(
                        r => {
                            resolve()
                        }
                    )
            }
        });
    }
}
